import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Button, Dialog, TextField } from "@material-ui/core";
import { useTranslation } from "localization/translation";
import * as Api from "service";
import { getQueryParam } from "helpers/getQueryParam";
import { USER_ID, PROMO_CODE_ERROR_MSG } from "Constants";
import useStore from "context";

export const LinkedCode = ({
  open,
  setOpen,
  setUserDetails,
  currentCode,
  title,
  fieldId,
  updateRequest,
  emptyErrorMessage,
  allowEmpty = false,
  helperText = "",
}) => {
  const translation = useTranslation();
  const location = useLocation();
  const { setErrorMsg } = useStore();

  const [codeValue, setCodeValue] = useState(currentCode || "");
  const userId = getQueryParam(location, USER_ID);

  useEffect(() => {
    setCodeValue(currentCode || "");
  }, [currentCode, open]);

  const cancelHandler = () => {
    setOpen(false);
  };

  const saveHandler = async () => {
    const code = String(codeValue || "").trim();
    if (!code && !allowEmpty) {
      setErrorMsg(emptyErrorMessage);
      return;
    }

    try {
      await updateRequest(userId, code);
      const { data } = await Api.main.getUserDetails(userId);
      setUserDetails(data);
      setOpen(false);
    } catch (error) {
      setErrorMsg(error?.message || emptyErrorMessage);
      setOpen(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={cancelHandler}
      classes={{ paper: "shadow-lg rounded" }}
    >
      <div className="text-center pt-2 pb-5 pl-5 pr-5">
        <h4 className="font-weight-bold mt-4">{title}</h4>
        <TextField
          id={fieldId}
          label={title}
          variant="outlined"
          value={codeValue}
          type="text"
          onChange={(e) => setCodeValue(e.target.value)}
          helperText={helperText || ""}
        />
        <div className="pt-4">
          <Button
            onClick={cancelHandler}
            className="btn-neutral-secondary btn-pill mx-1"
          >
            <span className="btn-wrapper--label">{translation.cancel}</span>
          </Button>
          <Button
            onClick={saveHandler}
            className={`btn-danger btn-pill mx-1 activate`}
          >
            <span className="btn-wrapper--label btn-action">
              {translation.save}
            </span>
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export const PromoCode = ({
  isPromoCodeMode,
  setIsPromoCodeMode,
  setUserDetails,
  promo_code,
}) => {
  const translation = useTranslation();

  return (
    <LinkedCode
      open={isPromoCodeMode}
      setOpen={setIsPromoCodeMode}
      setUserDetails={setUserDetails}
      currentCode={promo_code}
      title={translation.promo_code}
      fieldId="promo-code-field"
      emptyErrorMessage={PROMO_CODE_ERROR_MSG}
      updateRequest={(clientId, promoCode) =>
        Api.main.updatePromoCode({ clientId, promoCode })
      }
    />
  );
};
